import React from "react";
import Container from "../../styles/Container";
import { aboutData } from "./data";
import styled from "styled-components";
import { theme } from "../../styles/theme";
const AboutSection = styled.section`
  margin: 24rem auto 8rem auto;

  h4 {
    font-family: Roboto;
    margin-bottom: 2rem;
  }
  h1 {
    font-weight: 800;
    letter-spacing: 0.1rem;
    font-size: 6rem;
    background: conic-gradient(
      from 0.25turn at 50% 30%,
      var(--lightblue),
      10deg,
      var(--blue),
      350deg,
      var(--lightblue)
    );
    /* background: -webkit-linear-gradient(var(--blue), var(--black)); */
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;
const AboutHeader = styled.div`
  ${theme.maxWidth.twox};
  margin-bottom: 2rem;
`;

const AboutGrid = styled.div`
  display: grid;

  @media ${theme.devices.md} {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }

  @media ${theme.devices.lg} {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }
`;
const AboutItem = styled.article`
  padding: 3rem 3rem 3rem 0;

  .title {
    font-weight: 900;
  }
`;

const ImgWrap = styled.div`
  img {
    background: var(--grey);
    padding: 2rem;
    border-radius: 0.7rem;
  }
`;
export default function About() {
  return (
    <AboutSection>
      <Container>
        <AboutHeader>
          <h4>What we do</h4>
          <h1>The future of car wash and repairing</h1>
        </AboutHeader>
        <AboutGrid>
          {aboutData.map((about, index) => {
            return (
              <AboutItem key={index}>
                <ImgWrap>
                  <img src={about.img} alt={about.title} />
                </ImgWrap>
                <p className="title">{about.title}</p>
                <p>{about.body}</p>
              </AboutItem>
            );
          })}
        </AboutGrid>
      </Container>
    </AboutSection>
  );
}
